module.exports = __webpack_public_path__ + "static/background-5c6f518e3d175db469949c587fef0d21.png";